import * as React from "react";
import BillingInfo from "../common/BillingInfo";
import { AnyForNow } from '../../features/grn/types';

interface ViewGrnReturnInfoProps {
  grnPaySummery?: AnyForNow[];
  grnReturns?: AnyForNow[];
  grnItems?: AnyForNow[];
  grnReturnList?: AnyForNow[];
  grnReturnMaster?: AnyForNow[];
  Returncal?: AnyForNow[];
  grnPayTax?: AnyForNow[];
  grnData?: AnyForNow;
  totalGross?: number | string;
  taxValues?: AnyForNow;
  grnTaxTypes?: AnyForNow[];
  grncharges?: AnyForNow[];
  addedCharges?: AnyForNow[];
  origin?: string;
  returnedProducts?: AnyForNow[];
  billingSummary?: AnyForNow;
  processResponse?: AnyForNow[];
  grnreturncode?: string | number;
}

const ViewGrnReturnInfo: React.FC<ViewGrnReturnInfoProps> = (props) => {
  const {
    grnPaySummery = [],
    grnReturns = [],
    grnItems = [],
    grnReturnList = [],
    grnReturnMaster = [],
    Returncal = [],
    grnreturncode = null,
  } = props;

  // Helper to filter any array by grnreturncode
  const filterByReturnCode = (arr: AnyForNow[]): AnyForNow[] => {
    if (!grnreturncode || !Array.isArray(arr)) return arr;
    return arr.filter(
      (item) => String(item.grnreturncode) === String(grnreturncode)
    );
  };

  // Filter all data sources by grnreturncode upfront
  const filteredGrnReturns = filterByReturnCode(grnReturns);
  const filteredGrnReturnList = filterByReturnCode(grnReturnList);
  const filteredGrnReturnMaster = filterByReturnCode(grnReturnMaster);
  const filteredReturncal = grnreturncode
    ? Returncal.filter(
        (item) => String(item.grnreturncode) === String(grnreturncode)
      )
    : Returncal;

  // Get the latest return master-like record (filteredGrnReturnMaster or filteredGrnReturnList)
  const getLatestReturnMaster = (): AnyForNow | null => {
    const returnMasterSource =
      Array.isArray(filteredGrnReturnMaster) && filteredGrnReturnMaster.length > 0
        ? filteredGrnReturnMaster
        : filteredGrnReturnList;

    if (!Array.isArray(returnMasterSource) || returnMasterSource.length === 0) {
      return null;
    }

    const sorted = [...returnMasterSource].sort((a, b) => {
      const dateA = new Date(a.endate || 0).getTime();
      const dateB = new Date(b.endate || 0).getTime();
      return dateB - dateA;
    });

    return sorted[0] || null;
  };

  const latestReturnMaster = getLatestReturnMaster();

  // Helper function to check if a value is NOT empty
  const hasValue = (value: any): boolean => {
    return value !== null && value !== undefined && value !== "" && value !== "0.00";
  };

  // Determine which returns to use
  const localReturned = (() => {
    try {
      const parsed = JSON.parse(localStorage.getItem("returnedProducts") || "[]");
      return filterByReturnCode(parsed);
    } catch {
      return [];
    }
  })();

  const returnedProducts =
    Array.isArray(filteredGrnReturnList) && filteredGrnReturnList.length
      ? filteredGrnReturnList
      : localReturned;

  const grnReturnsData =
    Array.isArray(filteredGrnReturns) && filteredGrnReturns.length
      ? filteredGrnReturns
      : returnedProducts;

  // Get the latest return record
  const getLatestReturn = (): AnyForNow | null => {
    if (!Array.isArray(grnReturnsData) || grnReturnsData.length === 0) {
      return null;
    }

    const sorted = [...grnReturnsData].sort((a, b) => {
      const codeA = parseInt(a.grnreturncode || a.grnreturndetcode || 0);
      const codeB = parseInt(b.grnreturncode || b.grnreturndetcode || 0);
      if (codeB !== codeA) return codeB - codeA;

      const dateA = new Date(a.endate || 0).getTime();
      const dateB = new Date(b.endate || 0).getTime();
      return dateB - dateA;
    });

    return sorted[0] || null;
  };

  const latestReturn = getLatestReturn();

  const returnedQty = latestReturn?.returnedqty
    ? Number(latestReturn.returnedqty)
    : 0;

  const totalbeforetax = latestReturn?.totalbeforetax
    ? Number(latestReturn.totalbeforetax)
    : 0;

  const totaltax = latestReturn?.taxamount
    ? Number(latestReturn.taxamount)
    : 0;

  const finalTaxableAmount = hasValue(latestReturnMaster?.tottaxableamount)
    ? latestReturnMaster?.tottaxableamount
    : hasValue(latestReturnMaster?.totalbeforetax)
    ? latestReturnMaster?.totalbeforetax
    : hasValue(latestReturn?.tottaxableamount)
    ? latestReturn?.tottaxableamount
    : totalbeforetax;

  const finalTaxAmount = hasValue(latestReturnMaster?.tottaxamount)
    ? latestReturnMaster?.tottaxamount
    : totaltax;

  const finalTotal = hasValue(latestReturnMaster?.totaftertaxamount)
    ? latestReturnMaster?.totaftertaxamount
    : Number(finalTaxableAmount) + Number(finalTaxAmount);

  const parseNumber = (value: unknown): number | null => {
    if (value === null || value === undefined || value === "") {
      return null;
    }
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  };

  // Filter Returncal by grnreturncode and get the latest entry
  const latestReturncal =
    Array.isArray(filteredReturncal) && filteredReturncal.length > 0
      ? filteredReturncal[filteredReturncal.length - 1]
      : null;

  const summaryEntry =
    latestReturncal?.grnReturnSummaries &&
    Array.isArray(latestReturncal.grnReturnSummaries) &&
    latestReturncal.grnReturnSummaries.length > 0
      ? latestReturncal.grnReturnSummaries[
          latestReturncal.grnReturnSummaries.length - 1
        ]
      : null;

      console.log("summaryEntry", summaryEntry);

  const summaryBeforeTax =
    parseNumber(summaryEntry?.totalbeforetax) ??
    parseNumber(summaryEntry?.tottaxableamount);
  const summaryTaxAmount = parseNumber(summaryEntry?.tottaxamount);
  const summaryTotalValue = parseNumber(summaryEntry?.totreturnedvalue);

  const fallbackBeforeTax = parseNumber(finalTaxableAmount);
  const fallbackTaxAmount = parseNumber(finalTaxAmount);
  const fallbackTotal =
    parseNumber(latestReturnMaster?.totaftertaxamount) ??
    parseNumber(finalTotal);

  const effectiveBeforeTax = summaryBeforeTax ?? fallbackBeforeTax;
  const effectiveTaxAmount = summaryTaxAmount ?? fallbackTaxAmount;

  const billingDetails = [];

  if (effectiveBeforeTax !== null) {
    billingDetails.push({
      label: "Total Before Tax",
      value: effectiveBeforeTax,
    });
  }

  if (effectiveTaxAmount !== null) {
    billingDetails.push({
      label: "Total Tax",
      value: effectiveTaxAmount,
    });
  }

   const computedTotal =
    summaryTotalValue ??
    parseNumber(latestReturnMaster?.totaftertaxamount) ??
    fallbackTotal ??
    ((effectiveBeforeTax ?? 0) + (effectiveTaxAmount ?? 0));

  const totalValue = Number.isFinite(computedTotal)
    ? computedTotal
    : 0;

  return (
    <BillingInfo
      billingDetails={billingDetails}
      totalLabel="Total Value After Tax"
      total="Total"
      totalValue={totalValue}
    />
  );
};

export default ViewGrnReturnInfo;